var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vif)?_c('v-input',{attrs:{"prepend-icon":"mdi-phone","rules":[() => _vm.isValid || _vm.$t('identity.phoneFormat')],"error":!_vm.isValid,"persistent-hint":"","disabled":_vm.disabled}},[_c('vue-tel-input',_vm._g(_vm._b({attrs:{"input-options":{ id: _vm.selectId, placeholder: _vm.$t('identity.phone') },"auto-format:":"true","default-country":"FR","mode":"national","preferred-countries":['FR'],"dropdown-options":{
      showDialCodeInSelection: true,
      showFlags: true,
      width: '390px',
    }},on:{"input":_vm.setNumber}},'vue-tel-input',_vm.$attrs,false),_vm.$listeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }